import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import ecoConfig, { EcoType } from '../config';
import { getApps } from '../service/init';
import { ecoType } from '../const';
import { getLocalStorage } from '../tools';
/**
 * 自动生态鉴权，并获取返回的实例
 * @param orgId 
 * @param agentId 
 * @param corpId 
 * @returns 
 */

var initConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(orgId, agentId, corpId) {
    var app, configInstanse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            orgId = orgId || getLocalStorage('orgId');
            agentId = agentId || getLocalStorage('agentId');
            corpId = corpId || getLocalStorage('corpId');
            _context.next = 5;
            return getApp(orgId, agentId, corpId);

          case 5:
            app = _context.sent;

            if (app) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", Promise.reject('config failed: not found app'));

          case 8:
            console.log('current app:', app);
            configInstanse = configReady(app);
            return _context.abrupt("return", configInstanse);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initConfig(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * 根据机构ID返回当前生态下的应用列表
 * @param orgId 机构ID
 * @returns 应用列表
 */


var getApp = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(orgId, agentId, corpId) {
    var app, apps;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            app = null;
            orgId = orgId || window.localStorage.orgId;
            agentId = window.localStorage.agentId || '';
            agentId === 'null' && (agentId = '');
            corpId = window.localStorage.corpId || '';
            corpId === 'null' && (corpId = '');
            _context2.next = 8;
            return getApps(orgId, ecoType);

          case 8:
            apps = _context2.sent;

            if (!(!apps || !apps.length)) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", null);

          case 11:
            // 
            // 如果没有匹配的应用，则适配一个
            app = getAssignApp(apps, agentId, corpId) || getSingleApp(apps);
            return _context2.abrupt("return", app);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getApp(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * 传入指定agentId,corpId，尝试匹配
 * @param apps 
 * @param agentId 
 * @param corpId 
 * @returns 
 */


var getAssignApp = function getAssignApp(apps, agentId, corpId) {
  var app = null; // 传入指定agentId时，直接匹配

  if (agentId) {
    var list = apps.filter(function (app) {
      return app.appId === agentId;
    });

    if (list.length === 1) {
      app = list[0];
    } else if (list.length > 1 && corpId) {
      app = list.find(function (app) {
        return app.corpId === corpId;
      });
    }
  } // 在企业微信生态下，命中的服务号/公众号应用，无效（无法鉴权）


  if (app && app.weChatType === 1 && EcoType.qywx === ecoType) {
    app = null;
  }

  return app;
};
/**
 * 从应用列表中匹配出当前环境适用的应用对象
 * @param apps 应用列表
 * @returns 应用对象
 */


var getSingleApp = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(apps) {
    var getSingle, app;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if ([EcoType.qywx, EcoType.wx].includes(ecoType)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", apps.length === 1 ? apps[0] : null);

          case 2:
            // 识别出指定weChatType下，唯一的应用
            getSingle = function getSingle(weChatType) {
              var list = apps.filter(function (app) {
                return app.weChatType === weChatType;
              });
              if (list.length === 1) return list[0];
              return null;
            }; // 读取唯一的微信自建应用


            app = getSingle(0);

            if (!app && EcoType.wx === ecoType) {
              // 没有唯一自建应用时，在微信环境下下读取唯一的服务号
              app = getSingle(1);
            }

            return _context3.abrupt("return", app);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getSingleApp(_x7) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * 从应用列表中匹配出当前环境适用的应用对象，不进行自动鉴权
 * 由于某些SDK无需鉴权，此时只提供生态鉴权实例，并提供协议调用入口
 * @param apps 应用列表
 * @returns 应用对象
 */


var configReady = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(app) {
    var configData, configInstanse;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // 在app对象中附加EcoType，确保后续可以正常鉴权
            app.ecoType = ecoType; // 在微信生态下，鉴权实例，以返回的应用数据为准

            if ([EcoType.qywx, EcoType.wx].includes(ecoType)) {
              app.ecoType = app.weChatType === 1 ? EcoType.wx : EcoType.qywx;
            }

            configData = {
              agentId: app.appId,
              corpId: app.corpId
            };
            configInstanse = ecoConfig(app.ecoType, configData); // const configResult = await configInstanse.onReady();
            // if (!configResult) return Promise.reject('onReady failed')

            return _context4.abrupt("return", configInstanse);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function configReady(_x8) {
    return _ref4.apply(this, arguments);
  };
}();

export default initConfig;